import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import * as staticsApi from '../../lib/api/statics';
import OrderStaticsEmpTable from '../../components/obtainorder_statics/OrderStaticsEmpTable';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const ObtainorderStaticsEmp = ({
  selectedYear,
  strMonth,
  endMonth,
  tableRef,
  searchData,
  selectPrjTyp,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  // const onLoadData = () => {
  //   setLoading(true);
  //   const loadedHeaders = makeHeaderRow(strMonth, endMonth);
  //   const loadedData = makeGoalStaticsHeadquartData(loadedHeaders);

  //   setHeaderRows(loadedHeaders);
  //   setData(loadedData);
  //   setLoading(false);
  // };

  const onLoadData = async () => {
    setLoading(true);

    const searchData = {
      startDt: selectedYear + '-' + strMonth,
      endDt: selectedYear + '-' + endMonth,
    };

    try {
      const res = await staticsApi.getOrderStaticsByEmp(
        selectPrjTyp,
        searchData,
      );
      if (res.data.list) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchData) {
      onLoadData();
    }
  }, [searchData]);

  const content = loading ? (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>
  ) : (
    <OrderStaticsEmpTable
      data={data || []}
      loading={loading}
      tableRef={tableRef}
    />
  );

  return content;
};

export default ObtainorderStaticsEmp;
